<template>
    <b-container>
        <b-card class="pb-0" header="CRC Student Appointment Center" header-bg-variant="primary" header-text-variant="light" body-bg-variant="light">
            <b-form inline @submit="authenticateUser">
                <b-form-input id="username" :formatter="formatter" class="mb-2 mr-sm-2 mb-sm-0" v-model="username" :state="validator" placeholder="Enter your W#"></b-form-input>
                <b-form-input id="password" class="mb-2 mr-sm-2 mb-sm-0" v-model="password" type="password" placeholder="Password"></b-form-input>
                <b-button v-if="validator && !loading" type="submit" variant="success">Log-In</b-button>
                <b-button v-else-if="loading && validator" variant="success">&nbsp;&nbsp;&nbsp;<b-spinner small variant="light" type="grow" label="Spinning"></b-spinner>&nbsp;&nbsp;&nbsp;</b-button>
                <b-button v-else type="button" disabled>Log-In</b-button>
            </b-form>
        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "Authenticate",
        data(){
            return{
                username:"",
                password:"",
                authenticated:false,
                displayName:"",
                inStudentsGroup:true,
                ismember:false,
                isadmin:false,
                loading:false,
            }
        },
        methods:{
            formatter(value){
                const regex = /\d{7}/;
                if (value.length>8){
                    return value.substring(0,8);
                }
                value = value.toLowerCase();
                if(regex.test(value)){
                    if(!value.startsWith('w')) return "w"+value;
                    else{return value;}
                }
                else{return value;}
            },
            reloadPage(){
                location.reload();
            },
            authenticateUser(event){
                event.preventDefault();
                this.loading=true;
                if(this.username.length === 8) {
                    const formData = new FormData();
                    formData.append("user", this.username);
                    formData.append("pass", this.password);
                    formData.append("userdomain", "lrccd.ad.losrios.edu");
                    formData.append("groupdomain", "crc.ad.losrios.edu");
                    formData.append("group", "students-clear");
                    let urlReq = 'https://services.crc.ad.losrios.edu/CalmsPublicApi/api/operations/selfAssess';
                    this.$http.post(urlReq, formData, {
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8',
                            'Authorization': this.encodedAuth,
                            'Access-Control-Allow-Origin': '*',
                            'access-control-allow-credentials': 'true'
                        }
                    }).then((result) => {
                        this.authenticated = result.data.authenticated;
                        this.displayName = result.data.displayName;
                        this.ismember = result.data.isMember;
                        this.inStudentsGroup = result.data.inStudentsGroup;
                        this.$emit('dname', this.displayName);
                        this.$emit('uname', this.username);
                        this.$emit('pswd', this.password);
                        this.$emit('allowed',this.ismember);
                        this.$emit('inStudentsGroup',this.inStudentsGroup);
                        this.$emit('authenticated',this.authenticated);
                        this.loading = false;
                    });
                }
            },
        },
        computed: {
            validator() {
                const regex = /w\d{7}/;
                let roll = this.username.toLowerCase();
                return regex.test(roll);
            },
            encodedAuth(){
                let encoded = "Y3JjXHN2Yy1jYWxtczpzMzNteWxAYnM=";
                return "Basic "+encoded;
            },
        }
    }

</script>

<style scoped>

</style>